import { SurveyResults } from "@/features/survey-results/survey-results-types";
import { Survey } from "@/features/surveys/survey-types";
import { Prompt, runStructuredPrompt } from "./LLMService";
import { getSettings } from "./SettingsService";
import {
  SurveyAnalysis,
  SurveyAnalysisSchema,
} from "@/features/analyses/survey-analyses-types";

export async function analyseSurveyResults(
  survey: Survey,
  results: SurveyResults
): Promise<SurveyAnalysis> {
  const prompt = makeInsightslPrompt(survey, results);
  const analysis = await runStructuredPrompt<SurveyAnalysis>(
    prompt,
    SurveyAnalysisSchema
  );
  return analysis;
}

function makeInsightslPrompt(survey: Survey, results: SurveyResults): Prompt {
  const settings = getSettings();
  const systemPrompt = settings.insightsPrompt;
  const analystFacingData = {
    survey,
    results,
  };
  const userPrompt = JSON.stringify(analystFacingData);
  return { systemPrompt, userPrompt };
}
